//TODO remove eslint disable comment
/* eslint-disable @typescript-eslint/consistent-type-assertions */
import { queryString } from '@toggle/helpers';
import React from 'react';
import { matchRoutes, Navigate, RouteObject, useLocation } from 'react-router';

import {
  authRoutes,
  basicOrLightOnlyRoutes,
  commonRoutes,
  nonBasicOrLightRoutes,
  nonBasicRoutes,
} from '~/routes';
import { appPaths, authPaths } from '~/routes/app-paths';
import { queryKeys } from '~/routes/query-params';
import { AppRoute } from '~/routes/Routes';
import { useAuthStore } from '~/stores/use-auth/store/authStore';
import { useFlags } from '~/stores/use-flags/useFlags';
import { useSubscription } from '~/stores/use-subscription/useSubscription';
import { ServerError } from '~/views/error';

import { ErrorBoundaryWrapper } from '../error-boundary-wrapper/ErrorBoundaryWrapper';
import { AccountCheckView } from './account-check-view/AccountCheckView';

export const checkIsMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
};

export interface ProtectedRouteProps {
  config: AppRoute | RouteObject;
}

export const ProtectedView = ({ config }: ProtectedRouteProps) => {
  const location = useLocation();
  const isAuthenticated = useAuthStore(state => !!state.token);
  const isBasicUser = useSubscription(state => state.isBasicUser());
  const isBasicOrLightUser = useSubscription(state =>
    state.isBasicOrLightUser()
  );
  const getFeatureFlagState = useFlags(state => state.getFeatureFlagState);

  const isAuthRoute = matchRoutes(authRoutes, location);
  const isNonBasicRoute = matchRoutes(nonBasicRoutes, location);
  const isNonBasicOrLightRoute = matchRoutes(nonBasicOrLightRoutes, location);
  const isBasicOrLightOnlyRoute = matchRoutes(basicOrLightOnlyRoutes, location);

  if (!isAuthenticated) {
    const isCommonRoute = matchRoutes(commonRoutes, location);
    return isAuthRoute || isCommonRoute ? (
      config.element
    ) : (
      <Navigate
        to={
          authPaths.login +
          queryString({
            [queryKeys.redirect]: `${location.pathname}${location.search}`,
          })
        }
        replace
      />
    );
  }

  if (isAuthRoute) {
    const redirectPath = checkIsMobile() ? appPaths.alfred : appPaths.base;
    return <Navigate to={redirectPath} replace />;
  }

  if (
    (isBasicUser && isNonBasicRoute) ||
    (isBasicOrLightUser && isNonBasicOrLightRoute)
  ) {
    return <Navigate to={appPaths.base} replace />;
  }

  if (!isBasicOrLightUser && isBasicOrLightOnlyRoute) {
    return <Navigate to={appPaths.base} replace />;
  }

  const routesConfig = config as AppRoute;
  const featureFlagDisabled =
    routesConfig.featureFlag && !getFeatureFlagState(routesConfig.featureFlag);

  if (featureFlagDisabled) {
    return <Navigate to={appPaths.base} replace />;
  }

  return (
    <ErrorBoundaryWrapper fallback={<ServerError />}>
      <AccountCheckView config={routesConfig} />
    </ErrorBoundaryWrapper>
  );
};
